import { AutogenLayoutTopDriverReport } from "./autogen/AutogenLayoutTopDriverReport";

export class TopDriverReport extends AutogenLayoutTopDriverReport {
    
    override onLoad() {
        this.textboxDateType.selectedItem = this.textboxDateType.items[0];
        this.textboxDriverType.selectedItem = this.textboxDriverType.items[0];
        this.textboxSortBy.selectedItem = this.textboxSortBy.items[0];
        this.textboxSecondarySort.selectedItem = this.textboxSecondarySort.items[0];
    }

    onSelectPageBreakAfterDriverManager() {
        if (this.checkboxPageBreakAfterDriverFleet.checked == true) {
            this.checkboxPageBreakAfterDriverFleet.checked = false;
        }
        this.textboxSortBy.selectedItem = this.textboxSortBy.items[1];
    }

    onSelectPageBreakAfterDriverFleet() {
        if (this.checkboxPageBreakAfterDriverManager.checked == true) {
            this.checkboxPageBreakAfterDriverManager.checked = false;
        }
        this.textboxSortBy.selectedItem = this.textboxSortBy.items[3];
    }

    onSelectSortBy() {
        if (!this.textboxSortBy.selectedItem.equals(this.textboxSortBy.items[1])) {
            this.checkboxPageBreakAfterDriverManager.checked = false;
        }
        
        if (!this.textboxSortBy.selectedItem.equals(this.textboxSortBy.items[3])) {
            this.checkboxPageBreakAfterDriverFleet.checked = false;
        }
    }
}
